import { BCMSCurrency, BCMSDate, useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";

/**
 * @function TASPositivePayCreateTemplateFilePreviewWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Preview widget for the ImportFileNewTemplatePage.
 */
export default function TASPositivePayCreateTemplateFilePreviewWidget(props) {
    const { data } = useStateManager();
    
    const rows = data.checkTemplateRows.reduce((acc, item) => {
    var keys = Object.keys(item);
    
    // Create a string like the following: "Check Date", "Check Number", "Business", "Account Number", "Account Nickname", "Payee", "Amount", "Status").
    // Or like the following: "08/22/2025", "123", "ABC Company", "*1234", "Business Checking", "George", "100.00", "Created".
    var csvStr = keys.reduce((_acc, key, index) => {
        if(key === "_checkDate") {
            var dateValue = item[key];

            if(!isNaN(dateValue)) {
                _acc = _acc.concat(`"${ BCMSDate.init().offset(dateValue).format("m/d/Y") }", `);
            } else {
                _acc = _acc.concat(`"${ item[key] }", `);
            }
        } else if(key === "_amount") {
            var amountValue = item[key];

            if(!isNaN(amountValue)) {
                _acc = _acc.concat(`"${ BCMSCurrency.init(amountValue).format() }", `);
            } else {
                _acc = _acc.concat(`"${ item[key] }", `);
            }
        } else if(key !== "_positivePayCheckFile" && key !== "_id") {
            _acc = _acc.concat(`"${ item[key] }", `);
        }
        if(index === keys.length - 1) _acc = _acc.slice(0, -2);
        
        return _acc;
    }, "");
    acc.push(
        <p key={ item.id } className="file-preview-row">{ csvStr }</p>
    )
    return acc;
   }, []);
    
    return (
        <div className="tas-positive-pay-create-template-file-preview-widget">
            <h2>File Preview</h2>
            <p>Showing rows from beginning and end of file</p>
            <div className="file-preview-container ">
                { rows }
            </div>
        </div>
    )
}
